module.exports = __webpack_public_path__ + "static/media/img5.03eb4c61.jpg";